import { useParams } from "@tanstack/react-router";

/** Reads the client id from any route nested under /clients/$clientId. */
export function useClientId() {
  const params = useParams({ strict: false });
  return params.clientId as string;
}
